import { IFeedItemToken } from '@app/models/FeedItemToken'
import { DraftJsMentionPlugin } from 'gateway-draft-js-mention-plugin'
import * as React from 'react'

interface IFeedItemTokenSuggestionProps {
  mention: IFeedItemToken
  theme: DraftJsMentionPlugin.ITheme
  searchValue?: string
  isFocused?: boolean
}

export default class FeedItemTokenSuggestion extends React.PureComponent<IFeedItemTokenSuggestionProps> {
  public render() {
    const { mention, theme, searchValue, isFocused, ...parentProps } =
      this.props

    return (
      <div {...parentProps}>
        <div className='d-flex align-items-center'>
          <div className='mr-2'>
            <img
              src={mention.getImageUrl()}
              className={theme.mentionSuggestionsEntryAvatar}
            />
          </div>
          <div className='flex-grow-1'>
            {mention.name}
            {mention.isUser && (
              <img
                src='/images/HBlogo_Square_Image_Only.png'
                className='ml-2'
                width='15'
                height='15'
              />
            )}
          </div>
        </div>
      </div>
    )
  }
}
